import axios from 'axios';
import qs from 'qs';
// const slbExamUrlsApi = 'https://deep-slb-exam.ksbao.com/api'; //题库测试接口 fgs
// let ksurl = 'http://csp-api.yingedu.com/rpcl/testpaper/examTest' //抽题组卷
var RJDH = 'https://hzstg.ksbao.com/mypro?url=http://116.62.161.214:9999/RJDH'
var ksbServer = 'https://ksb-server.ksbao.com/card'
//正式站
if (true) {
  var mpt = 'https://mpt-api.ksbao.com/api';
  var baseUrls2 = 'https://csp-api.yingedu.com'; //试题正式站
  var baseUrls = 'https://deep-slb-user.ksbao.com/api'; //登录正式站
  var getUserInfoApi = "https://deep-slb-user.ksbao.com/api" //用户正式站
  var insertDateApi = "https://mpt-api.ksbao.com/api"; //用户答题记录
} else {
  // // //测试站
  var mpt = 'https://mpt-api-test.ksbao.com/api';
  var baseUrls2 = 'http://csp-api-test.yingedu.com'; //试题测试站
  var baseUrls = 'https://slb-user-test.ksbao.com/api'; //登录测试站
  var getUserInfoApi = "https://slb-user-test.ksbao.com/api" //用户测试站
  var insertDateApi = "http://mpt-api-test.ksbao.com/api"; //用户答题记录测试站
}


// ---------------------------------------------------------------------


export const userlogin = params => {
  return axios.post(mpt + `/ksbUser/mpopLogin`, params)
}
//抽奖的页面接口
// export const getPrize = params => {
//     return axios.get(`http://118.178.85.6:8060/lottery/getPrize`, {
//         params: params
//     })
// }

export const getcs = params => {
  return axios.get(`${baseUrls2}/rpcl/testpaper/examTest`, {
    params: params
  })
}
//跳转小程序生成链接
export const urlScheme = params => {
  return axios.post(`https://ksb-server.ksbao.com/card//ksbd/urlScheme`,
    params)
}
//联系客服跳转小程序
export const urlLink = params => {
  return axios.get(`https://ksb-server.ksbao.com/card//card//km/urlLink`, {
    params: params
  })
}
//试卷信息
export const examConfig = params => {
  return axios.get(`${baseUrls2}/rpcl/testpaper/examConfig`, {
    params: params
  })
}

export const sendlogincode = params => {
  return axios.post(`${baseUrls}/user/sendlogincode`, qs.stringify(params))
}
//检查账号是否注册 
export const checkUser = params => {
  return axios.get(`${baseUrls}/user/checkUser`, {
    params: params
  })
}
//注册获取短信验证码 https://slb-user-test.ksbao.com/api/user/sendcode
export const sendcode = params => {
  return axios.post(`${baseUrls}/user/sendcode`, qs.stringify(params))
}
//获取短信验证码登录
export const codelogin = params => {
  return axios.post(`${baseUrls}/user/codelogin`, qs.stringify(params))
}
//忘记密码 
export const resetPassword = params => {
  return axios.post(`${baseUrls}/user/restorePassword`, qs.stringify(params))
}
//做题记录
export const insertDates = params => {
  return axios.post(`${insertDateApi}/ctzj/handInExam`, params)
}

//用户信息
export const getUserInfo = params => {
  return axios.get(`${getUserInfoApi}/user/getUserInfo`, {
    params: params
  })
}
//获取地理位置
export const restapi = params => {
  return axios.get(`https://restapi.amap.com/v3/geocode/regeo`, {
    params: params
  })
}
export const restapiIp = params => {
  return axios.get(`https://restapi.amap.com/v5/ip`, {
    params: params
  })
}
//测评报告
export const getOne = params => {
  return axios.get(`${insertDateApi}/ctzj/testlogDetails`, {
    params: params
  })
}
export const vipApp = params => {
  return axios.get(`${baseUrls}/user/vipApp`, {
    params: params
  })
}
export const getWoYeBuZhiDao1Api = params => {
  return axios.get(`${RJDH}/api/answerLog/getWoYeBuZhiDao1?`, {
    params: params
  })
}
export const checkVip = params => {
  return axios.get(`${mpt}/ksbUser/checkVip`, {
    params: params
  })
}
export const rank = params => {
  return axios.get(`${mpt}/ctzj/rank`, {
    params: params
  })
}
export const getIp = params => {
  return axios.get(`${ksbServer}/ksbd/ip`, {
    params: params
  })
}

